import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_HOUSE_VALUE: MijnRoute = {
    path: 'hypotheken-woningwaarde',
    navigationEvent: 'toHypothekenWoningwaarde',
    regex: /^\/hypotheek\/hypotheken-woningwaarde$/,
    webcomponent: 'mijn-hypotheken-woningwaarde-webcomponent'
};
